<div id="map" class="public-maps section">
    <div class="container">
        <h4 class="section-subtitle">Onde nós estamos</h4>
        <h3 class="section-title">Venha tomar um café com a gente</h3>
        <label class="section-description">
            Vivencie e aproveite conosco a experiência de adquirir um novo veículo.
        </label>
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <div class="address-block">
                        <i class="fal fa-map-marker-alt icon"></i>
                        <b class="title">ENDEREÇO</b>
                        <label class="text">
                            Av. Sen. Marcos Freire, 850<br />Vila Brasil<br />São João da Boa Vista - SP<br />CEP 13875-044
                        </label>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="address-block">
                        <i class="fal fa-phone icon"></i>
                        <b class="title">TELEFONE</b>
                        <label class="text">
                            <table>
                                <tr>
                                    <td>(19) 3631 0101</td>
                                    <td>&nbsp;&nbsp;&nbsp;&nbsp;<span>Loja</span></td>
                                </tr>
                                <tr>
                                    <td>(19) 9 9402 1333</td>
                                    <td>&nbsp;&nbsp;&nbsp;&nbsp;<span>Luis Nora</span></td>
                                </tr>
                                <tr>
                                    <td>(19) 9 9744 6310</td>
                                    <td>&nbsp;&nbsp;&nbsp;&nbsp;<span>Tiago Batista</span></td>
                                </tr>
                            </table>
                        </label>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="address-block">
                        <i class="fal fa-envelope icon"></i>
                        <b class="title">E-MAIL</b>
                        <br class="only-above-mobile" />
                        <label class="text">megaautos21@gmail.com</label>
                    </div>
                </div>
            </div>
            <br /><br class="only-above-mobile" /><br class="only-above-mobile" /><br class="only-above-mobile" />
            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14799.459380418913!2d-46.7729608!3d-21.9781497!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c9cb9d47124fed%3A0xe1bd1f2585346706!2sMEGA%20AUTOS!5e0!3m2!1spt-BR!2sus!4v1696527727910!5m2!1spt-BR!2sus" width="100%" height="500" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
    </div>
</div>
<footer class="public-footer">
    <div class="container">
        <div class="row">
            <div class="col-md-4">
                MegaAutos - Copyright {{ currentYear }}
                <ng-container *ngIf="showAdminLink">
                    <br />
                    <a class="footer-admin-link" routerLink="/login">Área administrativa</a>
                </ng-container>
            </div>
            <div class="col-md-4"></div>
            <div class="col-md-4 display-flex align-items-center justify-content-flex-end">
                <i (click)="lnkInstagram()" class="fab footer-social-icon fa-instagram"></i>
                <!--<a href="#header" class="footer-home-link">
                    Voltar para o início
                    &nbsp;
                    <i class="fal fa-chevron-circle-up icon"></i>
                </a>-->
            </div>
        </div>
    </div>
</footer>